import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Docs from './Docs';
import Api from '../../services/ApiService';

const DocsContainer = props => {
  const { pageName } = props;
  const [content, setContent] = useState('');

  useEffect(() => {
    Api.get(`docs/${pageName}`).then(({ data }) => {
      setContent(data.docs);
    });
  }, []);

  return <Docs content={content} {...props} />;
};

DocsContainer.propTypes = {
  pageName: PropTypes.string,
};

export default DocsContainer;
